import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from "rxjs";
import { MessageService } from "primeng/api";
import { MenuService } from "../../../services/menus/menu.service";

@Component({
  selector: 'app-delete-subcategory',
  templateUrl: './delete-subcategory.component.html',
  styleUrls: ['./delete-subcategory.component.scss']
})
export class DeleteSubcategoryComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public spinner: boolean = false;
  public subcategoryId: string;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private menuService: MenuService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.subcategoryId = this.config.data.id;
    }
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  deleteSubcategory(id: string) {
    this.spinner = true;
    this.menuService.deleteSubcategory(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.ref.close(true);
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }
  //#endregion

}
